import { useState } from 'react';
import { User } from 'lucide-react';

import { cn } from '../../lib/utils';

export function getAvatarInitials(name?: string | null, email?: string | null): string {
    const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
    if (words.length > 0) {
        return (words[0][0] + (words.length > 1 ? words[words.length - 1][0] : '')).toUpperCase();
    }

    const normalizedEmail = (email ?? '').trim();
    return normalizedEmail ? normalizedEmail[0].toUpperCase() : '';
}

export function Avatar({
    src,
    initials,
    className,
}: {
    src?: string | null;
    initials: string;
    className?: string;
}) {
    const [failedSrc, setFailedSrc] = useState<string | null>(null);
    const showImage = Boolean(src) && failedSrc !== src;

    return (
        <span
            aria-hidden
            className={cn(
                'flex size-16 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary-100 text-lg font-semibold text-primary-600',
                className,
            )}
        >
            {showImage && src ? (
                <img
                    src={src}
                    alt=""
                    width={64}
                    height={64}
                    decoding="async"
                    className="size-full object-cover"
                    onError={() => setFailedSrc(src)}
                />
            ) : initials ? (
                initials
            ) : (
                <User className="size-1/2" aria-hidden />
            )}
        </span>
    );
}
